import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import ChatGPTUI from "./ChatGPTUI";
import SignIN from "./SignIN";
import ChatGPTCloneCleanUI2 from "./ChatgptUI2";
import ProtectedRoute from "./ProtectedRoute";
import Dashboard from "./Dashboard";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function App() {
  return (
    <Router>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Navigate to="/SignIn" />} />
        <Route path="/SignIn" element={<SignIN />} />
        <Route
          path="/chat"
          element={
            <ProtectedRoute>
              <ChatGPTUI />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

      </Routes>
    </Router>
  );
}

export default App;
